/**
 * Hooks
 */

// API Hooks
export * from "./api";

// APY Hooks
export * from "./apy";

// Geo Hooks
export { useGeoRestriction } from "./geo/useGeoRestriction";
export type { GeoRestrictionResult } from "./geo/useGeoRestriction";

// Token Hooks
export { useTokenMetadata } from "./useTokenMetadata";

// Transaction Flow
export { useTransactionFlow } from "./useTransactionFlow";
export type { TransactionBuildContext, TransactionFlowConfig, TransactionFlowReturn } from "./useTransactionFlow";

// Animation hooks
export { useCountUp } from "./useCountUp";

// Flow hooks
export { useFlowTimer } from "./useFlowTimer";

// Gesture hooks
export { useSwipeTabs } from "./useSwipeTabs";
export type { SwipeTabHandlers, UseSwipeTabsOptions, UseSwipeTabsResult } from "./useSwipeTabs";

// Viewport hooks
export { useIsMobileViewport } from "./useIsMobileViewport";

// Address verification
export { useSolanaAddressVerification, VERIFICATION_TONE_CLASS } from "./useSolanaAddressVerification";
export type {
    AccountType,
    SolanaAddressVerification,
    SolanaAddressVerificationStatus,
    SolanaAddressVerificationTone
} from "./useSolanaAddressVerification";

// Transaction lifecycle hooks (useTransactionPhase / useErrorReturnReady /
// useSuccessReturnReady / useSuccessAutoReturn / useBalanceSeek /
// useAutoDismissUserCancel / useTransactionForm) — moved from apps/main as Phase 1A of the
// external-consumption refactor so the widgets that consume them can
// also live in shared.
export * from "./transactions";
